module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAAKAQMAAABFQAhbAAAAA1BMVEUAbejZ+EJ6AAAAC0lEQVQI12MY5AAAAKAAAfgHMzoAAAAASUVORK5CYII="